import React, { Suspense, Fragment } from 'react';
// PROPTYPES
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//
import axios from 'axios';
//
//
import { getCustomId } from 'app/libs/core/Unique';
import { osName, isIE } from 'react-device-detect';
//
import { Type } from 'app/constants/TourPoints';
import { Button, Badge, Dropdown } from 'antd';
import { setPreviewTourData } from 'actions/Map/preview-marker-data.action';
import { setPreviewTourPoly } from 'actions/Map/preview-polyline.action';
import {
  loginModalOpen,
  setIsModalOpenFAQ,
  loginLegalIssuesModalOpen,
} from 'actions/Login/login.action';
import TweenOne from 'rc-tween-one';
import { FormattedMessage } from 'react-intl';
import { history } from 'app/store';
import TTIcon from 'static/img/svg/TT.svg';
import { DownloadTourGpsProps } from '../../PropType/propTypesDownloadTourGps';
import { RouterProps } from '../../PropType/propTypesRouter';
// REDUX
// ANTD

// import { TTSvgIcon } from '../MainMenu/svg';

import {
  openTourDownloadBasket,
  TourBasketDataDelete,
  openModalTourDownload,
  TourDownloadBasketData,
  TourDownloadDataClean,
  TourDownloadDataFromDB,
} from '../../../actions/TourDownload/tourDownloadGps.action';

// API
import userAPI from '../../../API/user.service.api';
import tourPrevAPI from '../../../API/tour.prev.api';

// UTILITY
import { openNotificationWithIcon } from '../../Utility/notificationMessage';

import { DownloadGps } from './downloadGps';

import { initListenerForTourstartTransfer } from './downloadGpsTT.services';

import './downloadGps.css';
import pageDataAPI from '../../../API/pageData.api';
import { TRASFER_GPS_TABS } from '../../../constants/transfer.constants';
import guestIdentService from '../../Utility/guestIdent.service';
import { retry } from '../../Utility/loadingChunkErrorHandler';

const guestIdentifier = guestIdentService();
const FaqComponent = React.lazy(() => retry(() => import('../FAQ/faq')));
const LegalIssues = React.lazy(() =>
  retry(() => import('../LegalIssues/legalIssues'))
);

let wasTTLaunched = true; // helps user if he canseled frirst launching of TT after click on TT button

class DownloadTourGpsContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      top: 0,
      left: 0,
      activeTab: TRASFER_GPS_TABS.DOWNLOAD,
      isProGpsAvailable: false,
      isDetectedTT: false,
      historyTourList: [],
      historyCheckedList: [],
      friendTourList: [],
      friendCheckedList: [],
      loadingFriendsTourList: false,
      myTourList: [],
      myCheckedList: [],
      loadingMyTourList: false,
      downloadTourList: [],
      downloadCheckedList: [],
      isOpenFAQ: false,
      isOpenLegal: false,
      identTT: '',
      activeTabKey: 'transfer',
      isNeedUpdateExistedTT: false,
      myTourLoadMore: false,
    };
    this.downloadGpsRef = React.createRef();
  }

  hanldleOpenTransferPanel = () => {
    const open = !this.state.open;
    const newState = {
      open,
      activeTabKey: 'transfer',
      isNeedUpdateExistedTT: false,
    };
    this.handleChangeActiveTab(TRASFER_GPS_TABS.DOWNLOAD);
    if (open) {
      const {
        downloadCheckedList,
        historyCheckedList,
        myCheckedList,
        friendCheckedList,
      } = this.state;
      if (downloadCheckedList.length > 0)
        newState.activeTab = TRASFER_GPS_TABS.DOWNLOAD;
      else if (historyCheckedList.length > 0)
        newState.activeTab = TRASFER_GPS_TABS.HISTORY;
      else if (myCheckedList.length > 0)
        newState.activeTab = TRASFER_GPS_TABS.MY_TOURS;
      else if (friendCheckedList.length > 0)
        newState.activeTab = TRASFER_GPS_TABS.FRIEND_TOURS;
      this.isProGpsAvailable();
      this.cleanMapAndCloseWindows();
    } else {
      newState.isDetectedTT = false;
    }
    this.setState(newState);
  };

  componentDidMount() {
    if (!this.isLogin() && this.state.downloadTourList.length === 0) {
      this.getDownloadTour();
    }
  }

  clearState = () => {
    this.setState({
      loadingMyTourList: false,
      myTourList: [],
      myCheckedList: [],
      friendTourList: [],
      friendCheckedList: [],
      loadingFriendsTourList: false,
      identTT: '',
      isProGpsAvailable: false,
    });
  };

  setCoord = () => {
    this.setState({
      top: this.props.downloadTourGps.coord[1] - 50,
      left: this.props.downloadTourGps.coord[0] - 20,
    });
  };

  setDownloadTourList = (data) => {
    this.setState({
      downloadTourList: data,
    });
  };

  changeState = () => {
    this.setState((state) => ({ ...state, open: false }));
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isLoggedIn !== prevProps.isLoggedIn) {
      if (this.props.isLoggedIn) {
        if (this.state.open) {
          this.isProGpsAvailable();
        }
        if (this.state.activeTab === TRASFER_GPS_TABS.MY_TOURS)
          this.getMyTourList();
      } else {
        this.props.TourDownloadDataClean();
        pageDataAPI.clearMyTours();
        this.clearState();
      }
    }

    if (this.props.historygps !== prevProps.historygps) {
      this.getHistoryTour();
    }

    if (this.props.downloadgps !== prevProps.downloadgps) {
      this.getDownloadTour();
    }

    if (prevState === this.state) {
      this.setCoord();
    }
    if (
      prevProps.downloadTourGps.data.length !==
      this.props.downloadTourGps.data.length
    ) {
      this.setDownloadTourList(this.props.downloadTourGps.data);
      const userId = this.getUserIndetifier();
      const data = this.props.downloadTourGps.data
        .filter((item) => item.id)
        .map((item) => {
          const { id } = item;
          const multiDay = item.parts && item.parts.length > 0 ? 1 : 0;
          const parts = item.parts ? this.getPartsId(item.parts) : [];
          const type = this.getScope(item);

          return { id, type, multiDay, parts };
        });
      userAPI.setHistorySelectedData(userId, 'downloadgps', data);
    }

    if (prevState.historyTourList !== this.state.historyTourList) {
      let set = new Set();
      this.state.historyTourList
        .filter((item) => item.id)
        .map((item) =>
          item.type ? set.add(item.id + item.type) : set.add(+item.id)
        );
      const availableList = Array.from(set);
      let param = availableList
        .map((id) => {
          let obj = null;
          this.state.historyTourList.forEach((item) => {
            const p = item.type ? item.id + item.type : item.id;
            const multiDay = item.parts && item.parts.length > 0 ? 1 : 0;
            const parts = item.parts ? this.getPartsId(item.parts) : [];

            if (p === id) {
              obj = { id: item.id, type: this.getScope(item), multiDay, parts };
            }
          });
          return obj;
        })
        .filter((i) => !!i);

      if (param.length > 10) {
        param = param.slice(0, 10);
      }

      userAPI.setHistorySelectedData(
        this.props.authUser.id,
        'historygps',
        param
      );
      set.clear();
      set = null;
    }
    if (
      this.props.router.location.pathname !==
        prevProps.router.location.pathname ||
      prevProps.mapClick !== this.props.mapClick ||
      prevProps.mapPos !== this.props.mapPos
    ) {
      this.changeState();
    }
  }

  getPartsId = (parts = []) => parts.map((item) => item.id);

  getUserIndetifier = () =>
    this.isLogin() ? this.props.authUser.id : guestIdentifier.get();

  showFAQ = () => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const isOpenFAQ = !this.state.isOpenFAQ;
    this.props.setIsModalOpenFAQ(isOpenFAQ);
    this.setState({ isOpenFAQ });
  };

  showLegal = () => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const isOpenLegal = !this.state.isOpenLegal;
    this.props.loginLegalIssuesModalOpen(isOpenLegal);
    this.setState({ isOpenLegal });
  };

  isUpdateAvailable = () => {
    // need check is TourstartTranfer have update
    return false;
  };

  handleChangeActiveTab = (activeTab) => {
    this.setState({ activeTab });
  };

  cleanMapAndCloseWindows = () => {
    this.props.setPreviewTourData({});
    this.props.setPreviewTourPoly({ id: 0, points: [], poly: '' });
  };

  unselectLoadedFiles = (scope) => {
    switch (scope) {
      case TRASFER_GPS_TABS.DOWNLOAD:
        this.setState({ downloadCheckedList: [] });
        break;
      case TRASFER_GPS_TABS.HISTORY:
        this.setState({ historyCheckedList: [] });
        break;
      case TRASFER_GPS_TABS.FRIEND_TOURS:
        this.setState({ friendCheckedList: [] });
        break;
      case TRASFER_GPS_TABS.MY_TOURS:
        this.setState({ myCheckedList: [] });
        break;
      default:
        break;
    }
  };

  transferRoutes = (tourList, checkedList, scope) => {
    if (!this.isLogin()) {
      this.props.loginModalOpen(true);
      return;
    }

    if (!this.state.isProGpsAvailable) {
      // need to launch without changin route
      history.push('/pro');
      return;
    }

    const downloadList = [];

    checkedList.forEach((id) => {
      tourList.forEach((item) => {
        if (item.multiDay === true) {
          item.parts.forEach((part, i) => {
            if (+part.id === +id) {
              downloadList.push({
                ...part,
                id: +part.id,
                title: `${item.title}_${i + 1}`,
                parent_tour_id: item.id,
              });
            }
          });
        } else if (+item.id === +id) {
          item.id = +item.id;
          downloadList.push(item);
        }
      });
    });

    const getURL = () => `${process.env.API_URL}/api`;
    axios({
      url: `${getURL()}/gps.checkIdent?ident=${this.state.identTT}`,
      method: 'GET',
      withCredentials: true,
    })
      .then((res) => {
        const { code, response } = res.data;

        if (code === 200 && response) {
          wasTTLaunched = true;
          const [update] = response.split('_');
          const isNeedUpdateTT = update === 'update';
          if (isNeedUpdateTT) {
            console.log('TT must be updated');
            this.changeActiveTabKey('install', true);
          } else if (downloadList.length > 0) {
            const ids = downloadList.map((el) => +el.id).filter((id) => !!id);
            console.log(
              'TT',
              downloadList,
              ids,
              scope,
              this.state.activeTab,
              tourList
            );
            const strIds = ids.join('_');
            console.log('getHrefTT', this.getHrefTT(`ids_${strIds}`));
            initListenerForTourstartTransfer(this.getHrefTT(`ids_${strIds}`));
            if (this.state.activeTab === TRASFER_GPS_TABS.DOWNLOAD)
              this.props.TourBasketDataDelete(ids);
            this.addToHistory(downloadList, ids, tourList);
            this.setState((state) => ({ ...state, open: false }));
            this.unselectLoadedFiles(scope, ids);
          } else {
            const text = (
              <FormattedMessage
                id="No tour selected for download"
                defaultMessage="No tour selected for download"
              />
            );
            openNotificationWithIcon('warning', text);
          }
        } else {
          console.log('Need to install TT');
          this.changeActiveTabKey('install');
        }
      })
      .catch((e) => {
        console.log('Need to install TT', e);
        this.changeActiveTabKey('install');
        wasTTLaunched = false;
      });
  };

  addToHistory = (downloadList, ids, tourList) => {
    const getTourFromBasket = (id) =>
      tourList.filter((item) => +item.id === +id);
    const tours = downloadList
      .filter((item) => +item.id)
      .map((item) =>
        item.parent_tour_id
          ? getTourFromBasket(item.parent_tour_id)[0]
          : { id: item.id, title: item.title, type: this.getScope(item) }
      );
    // eslint-disable-next-line react/no-access-state-in-setstate
    const data = this.state.historyTourList.filter(
      (val) => ids.indexOf(+val.id) === -1
    );

    this.setState({
      historyTourList: [...new Set(tours.concat(data.slice()))],
    });
  };

  download = (option) => {
    const { name, type, extension, reverse, tourAs } = option;
    let tourList = [];
    let checkedList = [];
    const downloadList = [];
    switch (this.state.activeTab) {
      case TRASFER_GPS_TABS.DOWNLOAD:
        tourList = this.props.downloadTourGps.data;
        checkedList = this.state.downloadCheckedList;
        break;
      case TRASFER_GPS_TABS.HISTORY:
        tourList = this.state.historyTourList;
        checkedList = this.state.historyCheckedList;
        break;
      case TRASFER_GPS_TABS.FRIEND_TOURS:
        tourList = this.state.friendTourList;
        checkedList = this.state.friendCheckedList;
        break;
      case TRASFER_GPS_TABS.MY_TOURS:
        tourList = this.state.myTourList;
        checkedList = this.state.myCheckedList;
        break;
      default:
        break;
    }

    checkedList.forEach((id) => {
      tourList.forEach((item) => {
        if (item.multiDay === true) {
          item.parts.forEach((part, i) => {
            if (+part.id === +id) {
              downloadList.push({
                ...part,
                title: `${item.title}_${i + 1}`,
                parent_tour_id: item.id,
              });
            }
          });
        } else if (+item.id === +id) {
          downloadList.push(item);
        }
      });
    });

    if (downloadList.length === 0) {
      const text = (
        <FormattedMessage
          id="No tour selected for download"
          defaultMessage="No tour selected for download"
        />
      );
      openNotificationWithIcon('warning', text);
      return;
    }

    if (!this.isLogin()) {
      this.props.loginModalOpen(true);
      return;
    }
    if (!this.state.isProGpsAvailable) {
      history.push('/pro');
      return;
    }
    downloadList.forEach((item, it) => {
      console.log(item);
      const scope = this.getScope(item);
      console.log(scope);
      if (it) {
        setTimeout(() => {
          tourPrevAPI.downloadGpx(
            item.title,
            item.id,
            name,
            scope,
            type,
            extension,
            reverse,
            tourAs
          );
        }, 700 * it);
      } else {
        tourPrevAPI.downloadGpx(
          item.title,
          item.id,
          name,
          scope,
          type,
          extension,
          reverse,
          tourAs
        );
      }
    });
    const ids = downloadList.map((el) =>
      el.parent_tour_id ? +el.parent_tour_id : +el.id
    );
    if (this.state.activeTab === TRASFER_GPS_TABS.DOWNLOAD)
      this.props.TourBasketDataDelete(ids);
    this.addToHistory(downloadList, ids, tourList);
    this.unselectLoadedFiles(this.state.activeTab, ids);
  };

  getScope = (item) => {
    return item?.scope || 'tour';
  };

  isLogin = () => {
    return this.props.isLoggedIn;
  };

  getCurrentUserId = () =>
    this.isLogin() && this.props.authUser && this.props.authUser.id;

  getIdentTT = () => {
    let { identTT } = this.state;
    if (!identTT) {
      identTT = `${this.getCurrentUserId()}_${getCustomId()}`;
      if (osName === 'Windows') {
        identTT += `_${process.env.TT_MIN_VER_WIN}`;
      } else {
        identTT += `_${process.env.TT_MIN_VER_MAC}`;
      }
      this.setState((store) => ({ ...store, identTT }));
    }
    return identTT;
  };

  getHrefTT = (params) => `tourstart:${this.getIdentTT()}:${params}`;

  launchEmptyTT = () =>
    initListenerForTourstartTransfer(this.getHrefTT(process.env.TT_CONST_TOUR));

  isProGpsAvailable = () => {
    userAPI
      .isProGpsAvailable()
      .finally(() => {
        this.setState({ isDetectedTT: true });
      })
      .then((res) => {
        const { code, response } = res;
        if (code === 200) {
          if (response.pro_gps_enabled) {
            // console.log('getCurrentUserId', this.getCurrentUserId(), 'osName', osName);
            if (this.state.identTT) {
              const getURL = () => `${process.env.API_URL}/api`;
              axios({
                url: `${getURL()}/gps.checkIdent?ident=${this.state.identTT}`,
                method: 'GET',
                withCredentials: true,
              })
                .then((res) => {
                  const { code, response } = res.data;
                  if (code !== 200 || !response) {
                    this.launchEmptyTT(); // trying to launch desctop TT without extra params
                  }
                })
                .catch(() => {
                  this.launchEmptyTT(); // trying to launch desctop TT without extra params
                });
            } else {
              this.launchEmptyTT(); // trying to launch desctop TT without extra params
            }
          }
          this.setState({
            isProGpsAvailable: response.pro_gps_enabled,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  closeDownloadGps = (value) => {
    this.setState({
      open: value,
    });
  };

  // MY Tour
  getMyTourList = (page = 0, firstLoad) => {
    const { myTourList } = this.state;
    if (this.props.authUser && this.props.authUser.id && this.isLogin()) {
      if (firstLoad) {
        this.setState({
          loadingMyTourList: true,
        });
      }
      setTimeout(() => {
        tourPrevAPI.getMyTourLazy(page).then((response) => {
          const { code, entities, loadMore } = response;
          if (code === 200) {
            this.setState({
              myTourList: [...myTourList, ...entities],
              loadingMyTourList: false,
              myTourLoadMore: loadMore,
            });
          }
        });
      }, 0);
    }
  };

  setMyCheckedList = (data) => {
    // const check = data.filter(i=>!this.state.myCheckedList.includes(i))
    // .concat(this.state.myCheckedList.filter(i=>!data.includes(i)));
    this.setState({
      myCheckedList: data,
    });
  };
  //

  // Friends Tour
  getFriendToursShortInfoById = (user_id, friend_id) => {
    if (friend_id === 'empty') {
      this.setState({
        friendTourList: [],
      });
      return;
    }
    this.setState({
      loadingFriendsTourList: true,
    });
    tourPrevAPI
      .getToursShortInfoByUserId(friend_id)
      .then((res) => {
        const { code, response } = res;
        if (code === 200) {
          this.setState({
            loadingFriendsTourList: false,
            friendTourList: response,
          });
        } else {
          console.log(res);
        }
      })
      .catch((err) => console.log(err));
  };

  setFriendCheckedList = (data) => {
    // const check = data.filter(i=>!this.state.friendCheckedList.includes(i))
    // .concat(this.state.friendCheckedList.filter(i=>!data.includes(i)));
    this.setState({
      friendCheckedList: data,
    });
  };
  //

  // History Tour
  getHistoryTour = () => {
    if (this.props.authUser && this.props.historygps) {
      this.setState({
        historyTourList: this.props.historygps.filter((item) => item.id),
      });
      // userAPI.getHistorySelectedData(this.props.authUser.id, 'historygps')
      // .then(res => {
      //     const {code, entities} = res;
      //     if(code === 200 && entities) {
      //         this.setState({
      //             historyTourList: entities.filter(item=>item.id)
      //         })
      //     }else{
      //         console.log(res);
      //     }
      // })
      // .catch(err => console.log(err));
    }
  };

  setHistoryCheckeList = (data) => {
    // const check = data.filter(i=>!this.state.historyCheckedList.includes(i))
    // .concat(this.state.historyCheckedList.filter(i=>!data.includes(i)));
    this.setState({
      historyCheckedList: data,
    });
  };

  //
  // Download
  getDownloadTour = () => {
    if (this.props.authUser && this.props.downloadgps) {
      this.props.TourDownloadDataFromDB(this.props.downloadgps);
      this.setState({ downloadTourList: this.props.downloadgps });
    }
    // const userId = this.getUserIndetifier();
    //     userAPI.getHistorySelectedData(userId, 'downloadgps')
    //     .then(res => {
    //         const {code, entities=[]} = res;
    //         if(code === 200) {
    //             this.props.TourDownloadDataFromDB(entities);
    //            this.setState({
    //                downloadTourList: entities
    //            })
    //         }else{
    //             console.log(res);
    //         }
    //     })
    //     .catch(err => console.log(err));
  };

  setDownloadCheckedList = (data) => {
    // const check = data.filter(i=>!this.state.downloadCheckedList.includes(i))
    // .concat(this.state.downloadCheckedList.filter(i=>!data.includes(i)));

    this.setState({
      downloadCheckedList: data,
    });
  };

  defaultDownloadCheckedList = () => {
    // this.setState({
    //     downloadCheckedList: data ? [data[0].id] : []
    // });
  };

  changeActiveTabKey = (activeTabKey, isNeedUpdateExistedTT = false) => {
    if (
      !wasTTLaunched &&
      this.state.activeTabKey === 'install' &&
      activeTabKey === 'transfer'
    ) {
      initListenerForTourstartTransfer(
        this.getHrefTT(process.env.TT_CONST_TOUR)
      );
    }
    this.setState((state) => ({
      ...state,
      activeTabKey,
      isNeedUpdateExistedTT,
    }));
  };

  getListStyleIE = (len = 0) => {
    let height = '87px';
    if (len > 3) {
      height = `${29 * 3}px`;
    }
    if (len > 10) {
      height = '290px';
    }
    return isIE ? { height } : {};
  };

  render() {
    const component = (
      <DownloadGps
        openTourDownloadBasket={this.props.openTourDownloadBasket}
        TourBasketDataDelete={this.props.TourBasketDataDelete}
        router={this.props.router}
        isUpdateAvailable={this.isUpdateAvailable}
        activeTab={this.state.activeTab}
        handleChangeActiveTab={this.handleChangeActiveTab}
        transferRoutes={this.transferRoutes}
        downloadData={this.state.downloadData}
        isLogin={this.isLogin}
        loginModalOpen={this.props.loginModalOpen}
        isProGpsAvailable={this.state.isProGpsAvailable}
        authUser={this.props.authUser}
        TourDownloadDataClean={this.props.TourDownloadDataClean}
        download={this.download}
        closeDownloadGps={this.closeDownloadGps}
        pathname={this.props.router.location.pathname}
        setIsModalOpenFAQ={this.props.setIsModalOpenFAQ}
        setIsModalOpenLegal={this.props.loginLegalIssuesModalOpen}
        // My Tour
        myTourList={this.state.myTourList}
        myCheckedList={this.state.myCheckedList}
        loadingMyTourList={this.state.loadingMyTourList}
        getMyTourList={this.getMyTourList}
        setMyCheckedList={this.setMyCheckedList}
        myTourLoadMore={this.state.myTourLoadMore}
        // Friend
        getFriendToursShortInfoById={this.getFriendToursShortInfoById}
        setFriendCheckedList={this.setFriendCheckedList}
        friendTourList={this.state.friendTourList}
        loadingFriendsTourList={this.state.loadingFriendsTourList}
        friendCheckedList={this.state.friendCheckedList}
        // History
        getHistoryTour={this.getHistoryTour}
        setHistoryCheckeList={this.setHistoryCheckeList}
        historyTourList={this.state.historyTourList}
        historyCheckedList={this.state.historyCheckedList}
        // Download
        setDownloadCheckedList={this.setDownloadCheckedList}
        downloadTourGps={this.props.downloadTourGps}
        downloadCheckedList={this.state.downloadCheckedList}
        getDownloadTour={this.getDownloadTour}
        showFAQ={this.showFAQ}
        showLegal={this.showLegal}
        activeTabKey={this.state.activeTabKey}
        changeActiveTabKey={this.changeActiveTabKey}
        isNeedUpdateExistedTT={this.state.isNeedUpdateExistedTT}
        getListStyleIE={this.getListStyleIE}
        isDetectedTT={this.state.isDetectedTT}
        launchEmptyTT={this.launchEmptyTT}
      />
    );

    const getCount = () =>
      this.props.downloadTourGps.data.length === 0
        ? null
        : this.props.downloadTourGps.data.length;

    return (
      <>
        <Dropdown
          overlay={component}
          visible={this.state.open}
          placement="bottom"
          overlayStyle={{ marginTop: 60 }}
          getPopupContainer={(trigger) => trigger.parentNode}
        >
          <Button
            className="GPSTranfer"
            onClick={this.hanldleOpenTransferPanel}
          >
            <div ref={this.downloadGpsRef} />
            <Badge count={getCount()} offset={[15, 0]}>
              <img src={TTIcon} alt="" style={{ height: 30, width: 55 }} />
              {/* <TTSvgIcon /> */}
              <span className="title">
                <FormattedMessage
                  id="Transfer GPS"
                  defaultMessage="Transfer GPS"
                />
              </span>
            </Badge>
          </Button>
        </Dropdown>

        {this.props.downloadTourGps.open === false ? null : (
          <TweenOne
            animation={{
              top: this.downloadGpsRef.current.getBoundingClientRect().top,
              left: this.downloadGpsRef.current.getBoundingClientRect().left,
              scale: 0.5,
              duration: 1000,
              onComplete: () => this.props.openModalTourDownload(false),
            }}
            style={{
              top: this.state.top,
              left: this.state.left,
            }}
            className="code-box-shape"
          />
        )}
        <Suspense fallback={<div />}>
          {this.state.isOpenFAQ ? (
            <FaqComponent
              customeCloseFunc={this.showFAQ}
              layoutStyle={{
                zIndex: 1101,
                position: 'fixed',
                top: '10vh',
                left: 0,
                right: 0,
              }}
              curtainStyle={{ position: 'fixed', zIndex: 1100 }}
            />
          ) : null}
        </Suspense>
        <Suspense fallback={<div />}>
          {this.state.isOpenLegal ? (
            <LegalIssues
              customeCloseFunc={this.showLegal}
              layoutStyle={{
                zIndex: 1101,
                position: 'fixed',
                top: '10vh',
                left: 0,
                right: 0,
              }}
              curtainStyle={{ position: 'fixed', zIndex: 1100 }}
            />
          ) : null}
        </Suspense>
      </>
    );
  }
}

DownloadTourGpsContainer.displayName = 'DownloadTourGpsContainer';

DownloadTourGpsContainer.propTypes = {
  TourBasketDataDelete: PropTypes.func,
  downloadTourGps: PropTypes.shape(DownloadTourGpsProps),
  openModalTourDownload: PropTypes.func,
  openTourDownloadBasket: PropTypes.func,
  router: PropTypes.shape(RouterProps),
};

const mapStateToProps = (store) => {
  return {
    downloadTourGps: store.tourDownload,
    router: store.router,
    isLoggedIn: store.authentication.isLoggedIn,
    authUser: store.authentication.user,
    mapPos: store.mapPostition.boundsUrl,
    mapClick: store.mapPostition.countMapClick,
    test: store.userHistoryReducer.data,
    downloadgps: store.userHistoryReducer.data.downloadgps,
    historygps: store.userHistoryReducer.data.historygps,
  };
};

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      openTourDownloadBasket,
      TourBasketDataDelete,
      openModalTourDownload,
      TourDownloadBasketData,
      TourDownloadDataClean,
      TourDownloadDataFromDB,
      loginModalOpen,
      setIsModalOpenFAQ,
      loginLegalIssuesModalOpen,
      setPreviewTourData,
      setPreviewTourPoly,
    },
    dispatch
  );
};
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(DownloadTourGpsContainer);
